import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { ApiVisa, ApiResponseModel } from '../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SubQueryService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'subquery';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'subquery';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'subquery';
    this.httpClient = http;
  }

  getGuidList(query:string,tableName:string, apiVisa: ApiVisa): Observable<ApiResponseModel<string>> {
    
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const body = {
      subquery : query,
      table : tableName
    };
    return this.httpClient.post<ApiResponseModel<string>>(this.apiUrl,body,this.getHttpHeader(apiVisa));
  }


}
